import { useEffect } from "react";
import Lenis from "lenis";

// Smooth momentum scrolling. Disabled when the user prefers reduced motion.
// Exposes the instance on window.__lenis and handles same-page hash links.
export function useSmoothScroll() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.6,
    });
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    // Intercept same-page hash anchors so lenis handles the scroll.
    const onClick = (e) => {
      const a = e.target.closest('a[href*="#"]');
      if (!a) return;
      const href = a.getAttribute("href");
      if (!href || href.startsWith("http")) return;
      const [path, hash] = href.split("#");
      const samePage = !path || path === window.location.pathname;
      if (hash && samePage) {
        const el = document.getElementById(hash);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80, duration: 1.1 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
}
